export const removeChildren = (node) => {
  const range = document.createRange();
  range.selectNodeContents(node);
  range.deleteContents();
};
